// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"773bcbfa","517":"f91b417d","832":"4945e6a2"}[chunkId] + ".chunk.js";
};